
import { Component, Vue } from "vue-property-decorator";
import ExamV3Custom, {
  ExamVDList,
  ExamVDListRequest,
  ExamVDVersionListRequest,
  ExamVDCandidateCount,
  ExamVDCandidateItem,
  ExamVDCandidateCountRequest,
  ExamV3
} from "@/lib/model/exambuilder/exam-v3/exam-v3";
import {
  ExamItem,
  BasicInformation
} from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";
import {
  HeaderColumn,
  examDefaultColumns,
  HeaderShowType
} from "../config/list";
import TimeUtil from "@/lib/common/time-util";
import EllipShow from "@/components/ellipShow.vue";
import TableSortDialog from "../components/tableSortDialog.vue";
import Auth from "@/lib/common/auth";
import ExamList from "@/lib/model/exam/exam";
import ExamInfo from "../components/exam-info.vue";
import ExamLink from "../components/exam-link.vue";
import ManageAuth from "../components/manage-auth.vue";
import SelectTemplate from "../components/select-template.vue";
import DelExam from "../components/del-exam.vue";
import AsyncDownloadModal from "../components/async-download-modal.vue";
import AddMoreCandidateModal from "@/views/exam-v3/components/add-candidates.vue";
import AddOneCandidateModal from "@/views/exam-v3/components/add-candidate.vue";
import Loading from "@/components/loading.vue";
import AIQaConfig from "@/views/ai-qa-officer/components/ai-qa-config.vue";

// 导出相关接口没有变化使用的还是旧版的
import Candidate, {
  CandidateMCreateParams,
  CandidateMCreateParseParams
} from "@/lib/model/exam/candidate";
import { CandidateListExportParams } from "@/lib/model/exam/candidate";
import CandidateCreateForm, {
  StructParam
} from "@/lib/form/candidate/CandidateCreateForm";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";

import vuexStore, { EnumEditStatus } from "@/store/vuex-store";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import { position } from "html2canvas/dist/types/css/property-descriptors/position";

@Component({
  name: "exam-list-v3",
  components: {
    AIQaConfig,
    AddOneCandidateModal,
    AddMoreCandidateModal,
    DelExam,
    ExamLink,
    ExamInfo,
    ManageAuth,
    SelectTemplate,
    AsyncDownloadModal,
    EllipShow,
    TableSortDialog,
    Loading
  }
})
export default class AiList extends Vue {
  name = "exam-list-v3";

  listParam = new ExamVDListRequest();
  candidateParam = new ExamVDCandidateCountRequest();
  examVDList = new ExamVDList();
  pageInfo = {
    page: 1,
    pageSize: 10
  };
  candidateList: ExamVDCandidateItem[] = [];
  tableLoading = false;
  candidateLoading = false;
  headerList: HeaderColumn[] = [];
  examStatus = 0;
  showSortSetting = false;
  controlRefresh = true;

  interval = 0;

  get examDefaultColumns() {
    return examDefaultColumns;
  }

  //内部使用 设置web页
  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }
  //跳旧版面试设置
  toSetWeb(row: any) {
    this.$router.push({
      name: "ai-builder",
      query: { paperId: row.examId, cid: Auth.companyId, step: "0" }
    });
  }

  get HeaderShowType() {
    return HeaderShowType;
  }

  created() {
    this.getList();
  }

  activated() {
    if (vuexStore.editStatus !== EnumEditStatus.EnumInit) {
      // 用户改变了详情一些配置，刷下列表，以后可能会单条刷新(clickRow)
      this.getList();
      vuexStore.setEditStatus(EnumEditStatus.EnumInit);
      // const i = this.examVDList.list.findIndex(item => item.examId === this.clickRow.examId)
      // const params = new ExamVDListRequest().assign({
      //   nameOrRemark: this.clickRow.name,
      //   page: 1,
      //   pageSize: 10
      // })
      // ExamVDList.getList(params).then(res => {
      //   console.log(res)
      // });
    }
    // console.log('12312')
  }

  mounted() {
    this.interval = setInterval(() => {
      this.examVDList.list.forEach(el => {
        el.dataChange = false;
        this.$nextTick(() => {
          el.dataChange = true;
        });
      });
    }, 1000);
    this.headerList = examDefaultColumns;
    const cacheHeaderList = localStorage.getItem("examlistv3" + Auth.userId);
    if (cacheHeaderList) {
      try {
        this.headerList = JSON.parse(cacheHeaderList);
      } catch (error) {
        this.headerList = examDefaultColumns;
      }
    }
    // 列表在setWeb下添加ID项
    if (this.setWeb) {
      const id = this.headerList.find(item => item.label === "面试ID");
      if (!id) {
        this.headerList.splice(
          1,
          0,
          {
            label: "面试ID",
            required: true,
            prop: "examIdForSetWeb",
            width: "120px",
            fixed: "left",
            isShow: true,
            draggable: false,
            respond: false,
            canWrap: true,
            sort: 2
          },
          {
            label: "面试批次ID",
            required: true,
            prop: "examVersionId",
            width: "120px",
            fixed: "left",
            isShow: true,
            draggable: false,
            respond: false,
            canWrap: true,
            sort: 3
          }
        );
        this.headerList = this.headerList.map((item, i) => {
          item.sort = i + 1;
          return item;
        });
      }
    } else {
      this.headerList = this.headerList.filter(item => item.label !== "ID");
    }
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }

  getRowKey(row: ExamItem) {
    return "" + row.examId + row.examVersionId;
  }

  getStatus(row: ExamItem) {
    const isEnd = new Date(row.endTime).getTime() < new Date().getTime();
    const unStart = new Date(row.beginTime).getTime() > new Date().getTime();
    const isPlaying = !isEnd && !unStart;
    if ((row.noEnding === 1 && !unStart) || isPlaying) {
      return 1;
    } else if (unStart) {
      return 3;
    } else {
      return 2;
    }
  }

  formatTimeToday(time: string) {
    return TimeUtil.formatTimeToday(time);
  }

  formatTimeSecond(useTimeSecond: number) {
    const m = Math.floor(useTimeSecond / 60);
    const s = useTimeSecond % 60;
    return `${m}分钟${s !== 0 ? s + "秒" : ""}`;
  }

  willEnd(endTime: string) {
    let str = "";
    const willEndHour =
      (new Date(endTime).getTime() - new Date().getTime()) / 1000 / 60 / 60;
    if (willEndHour < 72 && willEndHour > 0) {
      if (willEndHour > 48) {
        str = "2天后结束";
      } else if (willEndHour > 24) {
        str = "1天后结束";
      } else if (willEndHour > 1) {
        str = Math.floor(willEndHour) + "小时后结束";
      } else {
        const min = willEndHour * 60;
        if (min < 1) {
          str = Math.floor(min * 60) + "秒后结束";
        } else {
          str = Math.floor(min) + "分钟后结束";
        }
      }
    }
    return str;
  }

  getProgressWidth(examId: number, key: string, isSubVersion: boolean) {
    const item = this.getExamCandidate(examId, isSubVersion);
    return Math.round((item[key] / item.all) * 100) + "%";
  }

  changePageSize(pageSize: number) {
    this.pageInfo.pageSize = pageSize;
    this.getList();
  }

  changePageNumber(page: number) {
    this.pageInfo.page = page;
    this.getList();
  }

  getListForResetPage() {
    this.pageInfo.page = 1;
    this.getList();
  }

  showTableSetting() {
    this.showSortSetting = true;
  }

  expandRow: any = null;

  expandChange(row: any, expanded: boolean) {
    if (!expanded) {
      this.expandRow = null;
      return;
    }
    if (this.expandRow) {
      const table = this.$refs.examV3Table as any;
      if (table) {
        table.toggleRowExpansion(this.expandRow, false);
      }
    }
    this.expandRow = row;
  }

  load(tree: any, treeNode: any, resolve: any) {
    ExamVDList.getVersionList(
      new ExamVDVersionListRequest().assign({ examId: tree.examId })
    ).then((res: any) => {
      const len = res.data.list.length;
      const list = res.data.list.map((item: any, index: number) => {
        this.candidateList.push(
          new ExamVDCandidateItem().assign({
            ...item.candidateCount,
            examVersionId: item.examVersionId
          })
        );
        return new ExamItem().assign({
          positionName: tree.positionName,
          name: "批次" + (len - index),
          examBeginTogether: tree.examBeginTogether,
          noEnding: tree.noEnding,
          examId: item.examVersionId, // setWeb下展示
          examIdForSetWeb: tree.examIdForSetWeb, // setWeb下展示
          endTime: tree.endTime,
          beginTime: tree.beginTime,
          createdTime: item.createdTime,
          lastUpdateTime: item.lastUpdateTime,
          examVersionId: item.examVersionId,
          questionNumber: item.questionNumber,
          useTimeSecond: item.useTimeSecond,
          isLast: index === 0,
          isSubVersion: true,
          fatherExamId: tree.examId
        });
      });
      console.log(this.candidateList);
      resolve(list);
    });
  }

  clickRow = new ExamItem();

  toExamCandidates(row: ExamItem) {
    if (row.isSubVersion) {
      return;
    }
    // if (!row.isExamvd) {
    //   this.$message.error("当前面试不兼容重构版面试结构");
    //   return;
    // }
    this.clickRow = row;
    this.$router.push({
      path: "/exam/candidates",
      query: {
        examId: row.isSubVersion
          ? row.examVersionId.toString()
          : row.examId.toString()
      }
    });
  }

  getList() {
    this.tableLoading = true;
    this.candidateLoading = true;
    this.listParam.beforeStart = this.listParam.isPlaying = this.listParam.afterEnd = 0;
    switch (this.examStatus) {
      case 1:
        this.listParam.beforeStart = 1;
        break;
      case 2:
        this.listParam.isPlaying = 1;
        break;
      case 3:
        this.listParam.afterEnd = 1;
        break;
    }
    ExamVDList.getList(this.listParam.assign(this.pageInfo)).then(res => {
      this.examVDList = new ExamVDList().assign(res);
      this.examVDList.list.forEach(item => {
        item.hasVersion = !!(
          item.examVersionId !== item.examId && item.examVersionId
        );
      });
      this.tableLoading = false;
      if (this.examVDList.list.length) {
        this.getCandidateList(this.examVDList.list.map(exam => exam.examId));
      }
    });
  }

  goAiBuilder() {
    this.$router.push("/aihr-builder");
  }

  getCandidateList(examIdList: number[]) {
    this.candidateParam.examIdList = examIdList;
    ExamVDCandidateCount.getCandidateCount(this.candidateParam).then(res => {
      this.candidateLoading = false;
      this.candidateList = res.list;
    });
  }

  getExamCandidate(examId: number, isSubVersion?: boolean) {
    const item = this.candidateList.find(item => {
      if (isSubVersion) {
        return (item as any).examVersionId === examId;
      } else {
        return item.examId === examId;
      }
    });
    return item || new ExamVDCandidateItem();
  }

  refreshTable(headerList: HeaderColumn[]) {
    this.headerList = headerList;
    this.showSortSetting = false;
    this.controlRefresh = false;
    localStorage.setItem(
      "examlistv3" + Auth.userId,
      JSON.stringify(this.headerList)
    );
    this.$nextTick(() => {
      this.controlRefresh = true;
    });
  }

  // 弹窗
  rowExam = new ExamItem();

  async showDialog(scenes: string, row: ExamItem, e?: any) {
    if (!row || e?.disabled) return;

    this.rowExam = row;

    if (scenes === "link") {
      const params = {
        examId: row.examId,
        companyId: parseInt(Auth.companyId)
      };

      const wsaRes = await ExamList.wsaCode(params);

      if (wsaRes.code !== 0) return;

      this.showExamLink = true;
      this.scanLink = wsaRes.data.base64string
        ? `data:image/png;base64,${wsaRes.data.base64string}`
        : "";

      const urlRes = await ExamList.examUrl(params);

      if (urlRes.code !== 0) return;

      this.scanUrl = urlRes.data.url;

      return;
    }

    if (scenes === "addCandidate") {
      return this.showAddCandidate("one");
    }

    if (scenes === "addCandidates") {
      return this.showAddCandidate("more");
    }

    if (scenes === "examInfo") {
      this.examInfoMode = "edit";
      this.showExamInfo = true;
      this.isExamvd = row.isExamvd;
      this.editExamInfoParam = new BasicInformation().assign({
        name: row.name,
        remark: row.remark,
        positionId: row.positionId
      });
      return;
    }

    if (scenes === "copyExam") {
      this.examInfoMode = "copy";
      this.showExamInfo = true;
      this.editExamInfoParam = new BasicInformation().assign({
        name: row.name,
        remark: row.remark,
        positionId: row.positionId
      });
      return;
    }

    if (scenes === "removeExam") {
      this.showDelExam = true;
      this.delParam = {
        name: row.name,
        examId: row.examId
      };
      return;
    }

    if (scenes === "manageAuth") {
      this.showManageAuth = true;
      return;
    }

    if (scenes === "messageTemplate") {
      this.showSelectTemplate = true;
      return;
    }

    if (scenes === "exportCandidate") {
      this.exportCandidate();
      return;
    }

    // AI答疑官面试设置
    if (scenes === "aiQaConfig") {
      this.aiQaConfig(row);
      return;
    }

    if (scenes === "examQuestion") {
      this.$router.push({
        name: "aihr-builder",
        query: { paperId: row.examId as any, cid: Auth.companyId, step: "1" }
      });
      return;
    }
    if (scenes === "examConfig") {
      this.$router.push({
        name: "aihr-builder",
        query: { paperId: row.examId as any, cid: Auth.companyId, step: "4" }
      });

      return;
    }
  }

  isShowDownloadModal = false;

  exportCandidate() {
    let params;
    if (this.rowExam.isSubVersion) {
      params = ({
        companyId: Auth.companyId,
        examId: this.rowExam.fatherExamId,
        examVersionId: this.rowExam.examVersionId,
        asCompany: 0,
        isFsk: 0
      } as unknown) as CandidateListExportParams;
    } else {
      params = ({
        companyId: Auth.companyId,
        examId: this.rowExam.examId,
        asCompany: 0,
        isFsk: 0
      } as unknown) as CandidateListExportParams;
    }
    // this.tableLoading = true;
    // this.candidateLoading = true;
    Candidate.candidateListExport(params)
      .then(res => {
        if (res.code === 0) {
          if (res.data.isAsync === 1) {
            this.isShowDownloadModal = true;
          } else {
            const dataUrl = res.data.ossUrl;
            const a = document.createElement("a");
            a.href = dataUrl;
            a.setAttribute("download", "候选人列表");
            a.click();
          }
        }
      })
      .finally(() => {
        // this.tableLoading = false;
        // this.candidateLoading = false;
      });
  }

  // AI答疑官面试设置
  aiQaConfigVisible = false;
  aiQaConfigData = {
    examId: 0
  };
  aiQaConfig(row: any) {
    this.aiQaConfigData.examId = row.examId;
    this.aiQaConfigVisible = true;
  }

  // 邀请候选人弹窗
  showExamLink = false;
  scanLink = "";
  scanUrl = "";

  closeExamLink() {
    this.showExamLink = false;
    this.getList();
  }

  // 添加候选人
  isShowAddOne = false;
  isShowAddMore = false;
  candidateCreateForm = new CandidateCreateForm();
  examGetForm: ExamGetForm = new ExamGetForm();
  candidateMCreateParseParams = new CandidateMCreateParseParams();
  candidateMCreateParams = new CandidateMCreateParams();

  showAddCandidate(key: string) {
    this.examGetForm.examId = this.rowExam.examId;
    this.examGetForm.companyId = parseInt(Auth.companyId);
    this.candidateMCreateParseParams.companyId = parseInt(Auth.companyId);
    this.candidateMCreateParseParams.examId = this.rowExam.examId;
    this.candidateMCreateParams.examId = String(this.rowExam.examId);
    this.candidateMCreateParams.companyId = Auth.companyId;

    if (key === "one") {
      ExamList.examGet(this.examGetForm)
        .then(res => {
          this.candidateCreateForm.paramList = res.paramList.filter(
            (e: StructParam) => e.isShow == 1
          );
          this.candidateCreateForm.companyId = this.examGetForm.companyId;
          this.candidateCreateForm.examId = this.examGetForm.examId;
        })
        .finally(() => {
          this.isShowAddMore = false;
          this.isShowAddOne = true;
        });
    } else if (key === "more") {
      this.isShowAddOne = false;
      this.isShowAddMore = true;
    }
  }

  closeAddOneCandidate() {
    this.isShowAddOne = false;
    this.getList();
  }

  closeAddMoreCandidate() {
    this.isShowAddMore = false;
    this.getList();
  }

  // 编辑基本信息/复制面试
  examInfoMode = "edit";
  isExamvd = 0;
  showExamInfo = false;
  editShake = false;
  editExamInfoParam = new BasicInformation();

  async examInfoEditOk(data: BasicInformation) {
    if (this.editShake) return;

    this.editShake = true;

    if (this.examInfoMode === "edit") {
      if (this.isExamvd === 1) {
        // 重构版本走新接口
        const res = await ExamV3.update(
          new ExamV3Custom().assign({
            companyId: this.rowExam?.companyId || 0,
            examId: this.rowExam?.examId || 0,
            updateType: "basicInformation",
            basicInformation: data
          })
        );

        if (res.code !== 0) return;
      } else {
        // 通用版本走旧接口
        const res = await ExamV2Custom.updateName({
          examId: this.rowExam?.examId || 0,
          name: data.name,
          remark: data.remark,
          positionId: data.positionId
        });

        if (res.data.code !== 0) return;
      }

      this.$message.success("编辑成功");
    } else {
      const res = await ExamV3.copy({
        companyId: this.rowExam?.companyId || 0,
        examId: this.rowExam?.examId || 0,
        name: data.name,
        remark: data.remark,
        positionId: data.positionId
      });

      if (res.code !== 0) return;

      this.$message.success("复制成功");
    }

    this.editShake = false;
    this.showExamInfo = false;
    this.isExamvd = 0;
    this.getList();
  }

  // 编辑基本信息
  showDelExam = false;
  delParam = {
    examId: 0,
    name: ""
  };

  delCancel() {
    this.showDelExam = false;
  }

  async delSuccess() {
    const res = await ExamV3.delete(
      this.rowExam.examId,
      this.rowExam.companyId
    );

    if (res.code !== 0) return;

    this.showDelExam = false;
    this.$message.success("删除成功");
    this.getList();
  }

  showManageAuth = false;

  showSelectTemplate = false;

  setTemplateOK() {
    this.$message.success("保存成功");
    this.getList();
    this.showSelectTemplate = false;
  }
}
